// "Event created!" success sheet (components/admin/EventCreatedFlow.js): Share event + View check-in QR.
import React from "react";
import Modal, { ModalBody } from "../../../components/Modal";
import Icon from "../../../components/Icon";
import { Button } from "../../../components/primitives";
import { toDate } from "../../../lib/format";
import { dayLabel, timeLabel } from "../../../../../utils/eventDateParts";
import { useCopyText } from "../../../lib/clipboard";
import { eventShareLink } from "../../../../../utils/deepLinks";

export default function CreatedModal({ event, extra = 0, onClose, onViewQR }) {
  const copy = useCopyText();
  const d = toDate(event.start_date);
  return (
    <Modal title="Event created!" size="narrow" onClose={onClose} testId="eventCreated">
      <ModalBody>
        <div className="col" style={{ alignItems: "center", textAlign: "center", gap: 6 }}>
          <span className="gicon" style={{ background: "var(--gSuccess)" }}><Icon name="check" /></span>
          <b style={{ fontSize: 17 }}>{event.title}</b>
          {d && <div className="meta">{dayLabel(d)} · {timeLabel(d)}</div>}
          {extra > 0 && <div className="meta">and {extra} more date{extra === 1 ? "" : "s"}</div>}
        </div>
        <Button variant="pri" full icon="share" onClick={() => copy(eventShareLink(event.id), "Event link copied")} data-testid="eventCreated.share">Share event</Button>
        <Button variant="sec" full icon="qr" onClick={onViewQR} data-testid="eventCreated.viewQr">View check-in QR</Button>
      </ModalBody>
    </Modal>
  );
}
